import { Selector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { ApplicationState, WithEnterpriseId } from '@mews-commander/types';
import { mapBindingToPropSelector } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    getEnterpriseChainId,
    getEnterpriseDefaultCurrencyCode,
    getEnterpriseDefaultLanguageCode,
    getEnterpriseImageId,
    getEnterpriseAcceptedCurrencyCodes,
    getEnterpriseEditableHistoryIntervalMilliseconds,
    getEnterpriseOperationalEditableHistoryWindow,
    getEnterprise,
    getEnterpriseTimeZoneIdentifier,
    getEnterpriseCustomLinks,
    getEnterpriseName,
    getEnterpriseSubscriptionId,
    getEnterpriseLegalEnvironmentCode,
    isEnterpriseMultiTaxEnvironment,
    getEnterpriseAccommodationEnvironmentCode,
    getEnterpriseTaxEnvironmentCode,
    ExtendedEnterprise,
} from '../../ducks/enterprises';
import {
    getEnterpriseDefaultServiceId,
    getUserPreferredServiceId,
    hasEnterpriseServiceId,
} from '../enterpriseServices';
import { getEnterpriseCountryCode } from '../enterprises';
import { hasEnterpriseSmsIntegration } from '../../ducks/enterpriseIntegrations';

/** @deprecated use useCurrentEnterprise instead */
export const createCurrentEnterpriseIdPropsExtender = <P>() =>
    createPropsExtender<ApplicationState, P, string | undefined, WithEnterpriseId>(
        'enterpriseId',
        getCurrentEnterpriseId
    );

/** @deprecated use useCurrentEnterprise instead */
export const getCurrentEnterprise = composeProps(
    getEnterprise,
    createPropsExtender('enterpriseId', getCurrentEnterpriseId)
) as Selector<ApplicationState, ExtendedEnterprise>;

/** @deprecated use useCurrentEnterprise instead */
export const currentEnterpriseIdPropsExtender = createCurrentEnterpriseIdPropsExtender();
/** @deprecated use useCurrentEnterprise instead */
export const [
    hasCurrentEnterpriseServiceId,
    getCurrentEnterpriseServiceId,
    getCurrentEnterpriseUserPreferredServiceId,
    getCurrentEnterpriseDefaultLanguageCode,
    getCurrentEnterpriseEditableHistoryIntervalMilliseconds,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    getCurrentEnterpriseCustomLinks,
    isCurrentEnterpriseInMultiTaxEnvironment,
    getCurrentEnterpriseCountryCode,
    hasCurrentEnterpriseSmsIntegration,
] = mapBindingToPropSelector(currentEnterpriseIdPropsExtender)([
    hasEnterpriseServiceId,
    getEnterpriseDefaultServiceId,
    getUserPreferredServiceId,
    getEnterpriseDefaultLanguageCode,
    getEnterpriseEditableHistoryIntervalMilliseconds,
    getEnterpriseTimeZoneIdentifier,
    getEnterpriseCustomLinks,
    isEnterpriseMultiTaxEnvironment,
    getEnterpriseCountryCode,
    hasEnterpriseSmsIntegration,
]);

/** @deprecated use useCurrentEnterprise instead (e.g. `useCurrentEnterprise()?.name`) */
export const [
    getCurrentEnterpriseName,
    getCurrentEnterpriseSubscriptionId,
    getCurrentEnterpriseChainId,
    getCurrentEnterpriseDefaultCurrencyCode,
    getCurrentEnterpriseImageId,
    getCurrentEnterpriseAcceptedCurrencyCodes,
    getCurrentEnterpriseOperationalEditableHistoryWindow,
    getCurrentEnterpriseLegalEnvironmentCode,
    getCurrentEnterpriseAccommodationEnvironmentCode,
    getCurrentEnterpriseTaxEnvironmentCode,
] = mapBindingToPropSelector(currentEnterpriseIdPropsExtender)([
    getEnterpriseName,
    getEnterpriseSubscriptionId,
    getEnterpriseChainId,
    getEnterpriseDefaultCurrencyCode,
    getEnterpriseImageId,
    getEnterpriseAcceptedCurrencyCodes,
    getEnterpriseOperationalEditableHistoryWindow,
    getEnterpriseLegalEnvironmentCode,
    getEnterpriseAccommodationEnvironmentCode,
    getEnterpriseTaxEnvironmentCode,
]);
